<section class="perfil-telefonos" *ngIf="acceso">
  <div class="grid">
    <div class="col-12">
      <h3 class="perfil-telefonos-titulo">
        {{ "PERFILCREZCAMOS.LBL_AGREGARTELEFONO" | translate }}
      </h3>
    </div>
  </div>

  <!-- Formulario de telefono -->
  <div *ngIf="cargando" class="text-center">
    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
    <span>{{ "LBL_GUARDANDO" | translate }}</span>
  </div>
  <div class="grid">
    <div class="col-12"></div>
  </div>
  <div *ngIf="!cargando">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-5">
          <div class="div-form">
            <label
              >* {{ "PERFILCREZCAMOS.LBL_NUMEROTELEFONO2" | translate }}</label
            >
            <input
              type="text"
              pInputText
              id="numeroTelefono"
              name="numeroTelefono"
              autocomplete="off"
              formControlName="numeroTelefono"
              numero-telefono-reactive
              [maxLength]="14"
              [telFijo]="false"
            />
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submitted && fControls.numeroTelefono.invalid"
            >
              {{ "PERFILCREZCAMOS.LBL_NUMEROTELEFONO2" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-5">
          <div class="div-form">
            <label
              >* {{ "PERFILCREZCAMOS.LBL_QUIENSUMINISTRO" | translate }}</label
            >
            <p-dropdown
              id="idTipoSuministro"
              name="idTipoSuministro"
              [options]="listaTiposSuministrosTelefonos"
              placeholder="{{ 'LBL_SELECCIONE' | translate }}"
              formControlName="idTipoSuministro"
            ></p-dropdown>
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submitted && fControls.idTipoSuministro.invalid"
            >
              {{ "PERFILCREZCAMOS.LBL_QUIENSUMINISTRO" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
        <div class="col-12 lg:col-2">
          <div class="perfil-telefonos-options">
            <button
              type="submit"
              pButton
              class="p-button-success"
              icon="fa fa-floppy-o"
              label="{{ 'BTN_GUARDAR' | translate }}"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- listado de telefonos -->
  <div class="grid" *ngIf="!cargando">
    <div class="col-12">
      <h3 class="perfil-telefonos-titulo">
        {{ "PERFILCREZCAMOS.LBL_TELEFONOS" | translate }}
      </h3>
    </div>
    <div class="col-12">
      <p-table
        class="tabla-gris"
        [columns]="columnasTelefonos"
        [value]="listaTelefonos"
        [paginator]="true"
        [rows]="10"
        [responsive]="true"
        paginatorPosition="bottom"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="text-center">
              {{
                row.numeroTelefono !== null
                  ? (row.numeroTelefono | telefono)
                  : ("-" | translate)
              }}
            </td>
            <td class="text-center">
              {{
                row.tipoSuministro !== null
                  ? (row.tipoSuministro | translate)
                  : ("-" | translate)
              }}
            </td>
            <td class="text-center">
              {{
                row.auditoriaFecha !== null
                  ? (row.auditoriaFecha | date : "dd/MM/yyyy")
                  : "-"
              }}
            </td>
            <td class="text-center">
              <p-checkbox
                [(ngModel)]="row.indicadorPrincipal"
                binary="true"
                disabled="true"
              ></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group">
                <button
                  type="button"
                  class="p-button btn"
                  icon="fa fa-phone"
                  data-toggle="tooltip"
                  title="{{ 'BTN_LLAMAR' | translate }}"
                  pButton
                  (click)="llamar(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td class="text-center" [attr.colspan]="5">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</section>

<div class="no-hay-informacion" *ngIf="!acceso">
  <label>{{ "PERFILCREZCAMOS.LBL_SINACCESO" | translate }}</label>
</div>
